import { getGalileoAb } from '@/shared/galileoAb';
import { ABResEnum } from '@/enums/abExperiment';
import { ubtSendError } from '@/shared/utils/ubt';

/*
 * Fields组件AB分流测试管理类
 * 用于管理字段组件的AB实验分流逻辑
 */
class FieldsComponentsAb {
  /* AB分流实验结果缓存 */
  private isExperiment = false;

  /*
   * 初始化AB分流实验，获取并缓存实验结果
   * 实验地址: https://ab.hellobike.cn/experiment/detail/202509161145359039?isDetail=true
   * returns: 实验结果
   */
  public async initFieldComponentsAbResult(): Promise<void> {
    try {
      const res = await getGalileoAb().getAbResCatchError('202509161145359039', '202509161145359125');

      this.isExperiment = res?.result === ABResEnum.HINT;
    } catch (error) {
      ubtSendError(error as Error);
    }
  }

  /*
   * 读取缓存的AB测试结果
   */
  public getCachedResult(): boolean {
    return this.isExperiment;
  }
}

export default new FieldsComponentsAb();
